import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 440px;
`;

export const WrapperInputFile = styled.div``;
export const DropPlusIcon = styled.img`
  cursor: pointer;
`;
export const DragDrop = styled.div`
  border-radius: 8px;
  display: flex;
  gap: 0 8px;
  align-items: center;
  justify-content: center;
  padding: 20px 50px;
  border: 2px dashed #000;

  img,
  svg {
    filter: brightness(0) saturate(100%) invert(0%) sepia(84%) saturate(7500%)
      hue-rotate(329deg) brightness(89%) contrast(114%);
  }

  > div:nth-child(1) {
    border-radius: 100px;
    background: var(--blue-8, rgba(0, 80, 229, 0.08));
    padding: 16px;
  }

  > div:nth-child(2) {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  p {
    color: #3e4e65;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    max-width: 280px;

    > span {
      font-weight: 600;
    }
  }
`;
